import { render, staticRenderFns } from "./module5.vue?vue&type=template&id=8d17afee&scoped=true"
import script from "./module5.vue?vue&type=script&lang=js"
export * from "./module5.vue?vue&type=script&lang=js"
import style0 from "./module5.vue?vue&type=style&index=0&id=8d17afee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d17afee",
  null
  
)

export default component.exports